
<div class="data-printer" *ngIf="categories">
    <div class="category" *ngFor="let category of categories" [style.minWidth]="category.minWidth" [style.width]="category.width">
        <h3 class="category-name" *ngIf="category.name">
            {{ category.name }}
        </h3>
        <div class="item {{ item.template && item.className ? item.className : '' }}" *ngFor="let item of category.items">
            <span class="label" *ngIf="item.label">{{ item.label }}:</span>
            <span class="value {{ item.className ? item.className : '' }}" *ngIf="item.value !== undefined && item.value !== null" [innerHTML]="parseByType(item)" [style.textAlign]="item.alignment"></span>
            <ng-container [ngTemplateOutlet]="item.template" [ngTemplateOutletContext]="item.templateParams ? item.templateParams : {}" *ngIf="item.template"></ng-container>
        </div>
    </div>
</div>
